import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Addebito dal metodo di pagamento',
    [BillingMode.InternalInvoicing]: 'Addebito dalle vendite',
    active: 'Attivo',
    on_trial: 'In prova',
    launch_pending: 'In attesa della data di lancio',
    billing_disabled: 'Fatturazione disabilitata',
    on_grace_period: 'In periodo di grazia',
    past_due: 'Scaduto',
    cancelled: 'Annullato',
  },
};
